import React from "react";
import { useDropzone } from "react-dropzone";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { CategoryIcon } from "../../Assets/Icons";

const DropZone = ({ imageFor, edit, product, onFileUpload = () => {} }) => {
  const disabled = !edit;
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length === 1) {
        const file = acceptedFiles[0];
        onFileUpload(file);
      } else {
        console.error("Please select only one file");
      }
    },
    maxFiles: 1,
    multiple: false,
    disabled: disabled,
  });

  return (
    <>
      <div
        {...getRootProps({
          className: `dropzone ${disabled ? "dropzone-disabled" : ""}`,
          onClick: (event) => disabled && event.preventDefault(),
        })}
      >
        <input {...getInputProps()} disabled={disabled} />
        {product ? (
          <>
            <span className="img-upload-bg">
              {!edit ? (
                <>
                  <p>No Image</p>
                  <p>Found</p>
                </>
              ) : (
                <>
                  <p>UPLOAD</p>
                  <p>{imageFor}</p>
                </>
              )}
            </span>
          </>
        ) : (
          <>
            <FileUploadOutlinedIcon />
            <span className="dropzonimg">
              <CategoryIcon />
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default DropZone;
